import { LegendOptions } from '@sprinklr/stories/hyperspaceWidgets/types';
import { observable } from 'mobx';

export class LegendOptionsImpl implements LegendOptions {
    @observable enabled = true;
    @observable maxWidth = 300;
    @observable metric: LegendOptions['metric'] = {
        enabled: true,
        // leaving these commented out as we currently use the defaults and don't expose tunables
        // numberFormat: string;
        // key: string;
        // aggregation: 'sum' | 'max';
    };
    @observable position: LegendOptions['position'] = {
        auto: true,
        selectedPosition: 'top',
    };
    @observable size = 20;
}
